export default __webpack_public_path__ + "static/media/Banner_2560x500_4k.5228d3cd.png";